import { render } from "./DeleteTariffForm.vue?vue&type=template&id=6c1e04ee"
import script from "./DeleteTariffForm.vue?vue&type=script&lang=js"
export * from "./DeleteTariffForm.vue?vue&type=script&lang=js"

import exportComponent from "/home/misha/Рабочий стол/embody-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__